import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {

    constructor() { }

    public static isNullOrWhitespace(input) {
        if (typeof input === 'undefined' || input == null)
            return true;
        return input.replace(/\s/g, '').length < 1;
    }

    public static isNumber(evt, ) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
    
        if (charCode > 31 && (charCode != 46 && (charCode < 48 || charCode > 57)) || (charCode == 46 && evt.target.value.indexOf('.') != -1)) {
            return false;
        }
        return true;
      }

}
